import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import { DynamicIconDirective } from '@nai-libs/directives/dynicon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'nai-password-recovery-success',
    template: `
    <div class="page">
      <div class="wrapper-fluid">
        <span
          naiDynIcon
          [overrideColor]="false"
          [path]="'assets/icons/ok-check.svg'"
        ></span>
        <h1>{{ 'USER.PASSWORD_RECOVERY.SENT.TITLE' | translate }}</h1>
        <p>
          {{ 'USER.PASSWORD_RECOVERY.SENT.DESCRIPTION' | translate }}
        </p>
        <a
          [routerLink]="['login']"
          [mat-dialog-close]
          class="button button--outline button--primary"
          >{{ 'USER.PASSWORD_RECOVERY.SENT.BUTTON' | translate }}</a
        >
      </div>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./password-recovery-success-page.component.scss'],
    standalone: true,
    imports: [
        DynamicIconDirective,
        RouterLink,
        MatDialogModule,
        TranslateModule
    ],
})
export class PasswordRecoverySuccessPageComponent {}
